(ns app.front.view.licence.table
  "Common code for licence / CR tables"
  (:require [app.domain.licence.generic-model :as gl-model]
            [app.front.view.licence.util :as licence-util]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub]]
            [core.front.href :as href]))

(defn format-date [date-fn licence date]
  (date-fn (date-util/to-tz date (-> licence :domain/authority-group :group/tz))))

(def issue-date-column
  "Issue date column specification for modern responsive table"
  [:licence/issue-date
   (fn [licence]
     (if-some [issue-date (gl-model/issue-date licence)]
       (format-date (<sub [::date-util/date-fn]) licence issue-date)
       "-"))])

(def expiry-date-column
  "Expiry date column specification for modern responsive table"
  [:licence/expiry-date
   (fn [licence]
     (let [valid-to (gl-model/get-valid-to licence)]
       (if valid-to
         (format-date (<sub [::date-util/date-fn]) licence valid-to)
         "-")))])

(defn state-column [tr]
  [:domain/state
   (comp tr vector :domain/state)
   {:max-width 150}])

(defn get-status [licence]
  (cond
    (licence-util/valid? licence)                :ok
    (licence-util/licence-expires-soon? licence) :warning
    :else                                        :critical))

(defn href [licence]
  (href/href :view/licence {:group-id   (-> licence :domain/authority-group :group/id)
                            :licence-id (:licence/id licence)}))
